import * as React from 'react';

import BaseTransactionListLayout from './BaseTransactionListLayout';

export default function (params) {
  return BaseTransactionListLayout();
};
